import React from "react";
import "./ordersdetails.scss";
import OverlayLoading from "../../../common/OverlayLoader/Overlayloader";
import { TitleHeader } from "../../../components";

import {
  FiPackage,
  FiClock,
  FiMapPin,
  FiTruck,
  FiCheckCircle,
  FiUser,
  FiPhone,
  FiPlusCircle,
  FiCalendar,
  FiDollarSign,
  FiMessageCircle,
  FiArrowLeft,
} from "react-icons/fi";

import { HiOutlineTruck } from "react-icons/hi";
import useOrderDetailsUtils from "./ordersdetailsUtils";
import { ucfirst } from "../../../utils/customFn";
import { FaArrowLeft } from "react-icons/fa";

const OrderDetails = () => {
  const breadcrumbs = [
    { label: "Pages", link: "" },
    { label: "Add Page", link: "" },
  ];

  const {
    formData,
    loading,
    fetchData,
    formatDateTime,
    navigate,
  } = useOrderDetailsUtils();

  const SERVICE_TYPES = {
    EXPRESS: 1,
    TRUCK: 2,
    RIDESHARING: 3,
    PICKUP_TRUCK: 4,
    TOWING: 5,
  };

  const getStatusColor = () => {
    switch (formData?.status) {
      case "Accepted":
        return "#00A34B";
      case "Collecting":
        return "#A2845E";
      case "accepted":
        return "#D8DB47";
      case "Delivering":
        return "#4633afd1";
      case "Completed":
        return "#1F52F4";
      case "Cancelled":
        return "#DB0000";
      case "Pending":
        return "#E3BF33";
      default:
        return "#6c757d";
    }
  };

  // Reusable Components
  const DetailRow = ({ icon, label, value }) => (
    <div className="detail-item">
      <span className="detail-icon">{icon}</span>
      <div>
        <div className="detail-label">{label}</div>
        <div className="detail-value">{value || "N/A"}</div>
      </div>
    </div>
  );

  const TimelineItem = ({ date, location, status, isLast }) => (
    <div className="timeline-item">
      <div className="timeline-marker" />
      {!isLast && <div className="timeline-line" />}
      <div className="timeline-content">
        <div className="timeline-date">{date}</div>
        <div className="timeline-location">{location}</div>
        <div className="timeline-status">{status}</div>
      </div>
    </div>
  );

  return (
    <>
      <TitleHeader heading="Order Details" breadcrumbs={breadcrumbs} />

      <OverlayLoading isLoading={loading}>
        <div className="shipment-details-container">
          {/* <div className="back-button-container">
            <button 
              onClick={() => navigate(-1)} 
              className="back-button"
            >
              <FiArrowLeft className="back-icon" />
              Back to Orders
            </button>
          </div> */}
          <div className="shipment-header">
            <h1>
              <button
                className="back-button"
                onClick={() => navigate(-1)} // Go back to previous page
                aria-label="Go back"
              >
                <FaArrowLeft className="back-icon" />
              </button>
              <FiPackage className="header-icon" />
              Shipment #SHIP{formData?.id}
              {formData?.status?.toLowerCase() == "cancelled" ? (
                <div
                  className="status-badge"
                  style={{ backgroundColor: getStatusColor() }}
                >
                  Cancelled By {ucfirst(formData?.canceled_by)}
                </div>
              ) : (
                <div
                  className="status-badge"
                  style={{ backgroundColor: getStatusColor() }}
                >
                  {ucfirst(formData?.status)}
                </div>
              )}
            </h1>

            <div className="d-flex">
              <button
                className="btn d-flex align-items-center gap-2 px-3 py-2 rounded-pill shadow-sm text-white"
                style={{ backgroundColor: "#0d6efd" }}
                onClick={() => navigate(`/order/chat/${formData?.id}`)}
              >
                <FiMessageCircle size={18} />
                Chat
              </button>
            </div>
          </div>

          <div className="shipment-grid">
            {/* Main Details Section */}
            <div className="details-card">
              <h2>
                <FiTruck /> Shipment Information
              </h2>
              <div className="detail-row">
                <DetailRow
                  icon={<FiMapPin />}
                  label="Origin"
                  value={formData?.pickup_location}
                />
                <DetailRow
                  icon={<FiMapPin />}
                  label="Destination"
                  value={formData?.dropoff_location || formData?.getCity?.name}
                />
              </div>

              <div className="detail-row">
                <DetailRow
                  icon={<FiCalendar />}
                  label="Order Date"
                  value={formatDateTime(formData?.createdAt)}
                />

                <DetailRow
                  icon={<FiDollarSign />}
                  label="Driver offer Price"
                  value={formData?.driver_price || "N/A"}
                />
              </div>
              {SERVICE_TYPES?.RIDESHARING != formData?.service_id && (
                <div className="detail-row">
                  <DetailRow
                    icon={<FiClock />}
                    label="Estimated Delivery"
                    value={formData?.delivery_time}
                  />

                  <DetailRow
                    icon={<FiMapPin />}
                    label="Deliver Within"
                    value={
                      formData?.getDeliveryTime?.delivery_schedules_descriptions
                        ?.title || "N/A"
                    }
                  />
                </div>
              )}

              <div className="detail-row">
                {SERVICE_TYPES?.RIDESHARING != formData?.service_id && (
                  <DetailRow
                    icon={<FiPhone />}
                    label="Receiver number"
                    value={formData?.receiver_number}
                  />
                )}
                <DetailRow
                  icon={<FiPlusCircle />}
                  label="Extra Services"
                  value={
                    formData?.pickup_drop
                      ? "Pickup & Drop on"
                      : "Pickup & Drop off"
                  }
                />
              </div>

              <div className="specs">
                {SERVICE_TYPES?.TRUCK == formData?.service_id ||
                SERVICE_TYPES?.PICKUP_TRUCK == formData?.service_id ||
                SERVICE_TYPES?.TOWING == formData?.service_id ? (
                  <>
                    <div className="spec-item">
                      <span>Truck Type:</span>
                      <strong>{ucfirst(formData.truck_type)}</strong>
                    </div>

                    <div className="spec-item">
                      <span>Vehicle Type:</span>
                      <strong>
                        {
                          formData?.getVehicleType?.vehicleTypeDescription
                            ?.title
                        }
                      </strong>
                    </div>
                  </>
                ) : SERVICE_TYPES?.EXPRESS == formData?.service_id ? (
                  <>
                    <div className="spec-item">
                      <span>Size & Weight:</span>
                      <strong>
                        {" "}
                        {
                          formData?.shipment_size?.size_descriptions?.title
                        } &{" "}
                        {
                          formData?.shipment_size?.size_descriptions
                            ?.weight_limit
                        }
                      </strong>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="spec-item">
                      <span>Total Passenger </span>
                      <strong> {formData?.passenger_count}</strong>
                    </div>
                  </>
                )}

                <div className="spec-item">
                  <span>Service Type:</span>
                  <strong>
                    {formData?.getService?.service_descriptions?.title}
                  </strong>
                </div>
              </div>
            </div>

            {/* Services Section */}
            <div className="services-card">
              <h2>
                <FiCheckCircle /> Shipment Content
              </h2>
              <div className="service-tags">
                {formData?.getOrderShipContent &&
                  formData?.getOrderShipContent.map((item, index) => (
                    <div className="d-flex service-tag gap-1">
                      <div className="">
                        <img src={item?.icon_url} />
                      </div>
                      <span key={index} className="">
                        {item?.shipment_content_description?.name}
                      </span>
                    </div>
                  ))}
              </div>
              <div className="contact-details-grid mt-4">
                {/* Driver Details */}
                <div className="">
                  <h2>
                    <FiTruck /> Driver Details
                  </h2>
                  <div className="detail-column">
                    <DetailRow
                      icon={<FiUser />}
                      label="Driver Name"
                      value={formData?.getDriver?.name}
                    />
                    <DetailRow
                      icon={<FiPhone />}
                      label="Contact Number"
                      value={formData?.getDriver?.phone_number}
                    />

                    <DetailRow
                      icon={<HiOutlineTruck />}
                      label="Car name"
                      value={formData?.getDriver?.car_name}
                    />
                  </div>
                </div>

                {/* Client Details */}
                <div className="">
                  <h2>
                    <FiUser /> Shipper Details
                  </h2>
                  <div className="detail-column">
                    <DetailRow
                      icon={<FiUser />}
                      label="Client Name"
                      value={formData?.user?.name}
                    />
                    <DetailRow
                      icon={<FiPhone />}
                      label="Contact Number"
                      value={formData?.user?.phone_number}
                    />
                  </div>
                </div>
              </div>
            </div>

            {Array.isArray(formData.tracking) && formData.tracking.length > 0 && (
              <div className="timeline-card">
                <h2>
                  <FiClock /> Tracking History
                </h2>
                <div className="timeline">
                  {formData.tracking.map((event, index) => (
                    <TimelineItem
                      key={index}
                      date={event.date}
                      location={event.location}
                      status={event.status}
                      isLast={index === formData.tracking.length - 1}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>

          {formData?.notes && (
            <div className="contact-details-grid">
              <div className="details-card client-card">
                <h2>Notes</h2>

                <div>
                  <p>{formData?.notes}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </OverlayLoading>
    </>
  );
};

export default OrderDetails;
